export default __webpack_public_path__ + "static/media/NewLogo.d55f303b.png";